import { FC } from 'react';
import { PageProps } from '../../components/page';
import { useSearch } from '@tanstack/react-router';
import SplashMessage from './splash-message';
import PageCard from '@/components/page-card';

const SplashPage: FC<PageProps> = () => {
  const { action, destination, traceId, code, redirectUrl } = useSearch({ from: '/splash' });

  return (
    <PageCard>
      <SplashMessage
        action={action}
        destination={destination}
        traceId={traceId}
        code={code}
        redirectUrl={redirectUrl}
      />
    </PageCard>
  );
};

export default SplashPage;
